export default __webpack_public_path__ + "static/media/dukedumont.da09be01.JPG";